import GameObject from '../../GameObject/GameObject';
import Container from '../Container';
import Point from '../../Utility/Point';
import Sprite from '../Sprite';
import AnimationComponent from '../../Component/Animation';

export default class Arrow extends Container {
    protected onCreate(params: any): void {
        super.onCreate(params);

        const arrowSprite = GameObject.Instantiate(Sprite, {
            texture: 'FTUE_Arrow',
            anchor: new Point(0.5, 0.5),
        });
        arrowSprite.addComponent(AnimationComponent, {
            playOnStart: true,
            clipName: 'ArrowBounceLoop',
        });

        this.addChild(arrowSprite);
    }
}
